import { useEvent } from '../../../../../hooks/useEvent';
import { fieldPathBuilders } from '../../../shared/configs/acceptanceForm';
import { useFormMethods } from '../../../../../helpers/formManager';
import { useImmutabilityChecks } from '../immutabilityChecksProvider';

export const useDeskIsImmutable = (index) => {
  const immutabilityChecks = useImmutabilityChecks();
  const deskId = useGetDeskIdByIndex(index);

  return immutabilityChecks?.desk?.(deskId) ?? false;
};

export const useCreateDayIsImmutableFn = (index) => {
  const immutabilityChecks = useImmutabilityChecks();
  const deskId = useGetDeskIdByIndex(index);

  return useEvent((day) => {
    return immutabilityChecks?.day?.(deskId, day) ?? false;
  });
};

export const useDayIsImmutable = (deskIndex, dayId) => {
  const immutabilityChecks = useImmutabilityChecks();
  const deskId = useGetDeskIdByIndex(deskIndex);

  return immutabilityChecks?.day?.(deskId, dayId) ?? false;
};

export const useUniqueRangeIsImmutable = (deskIndex, rangeStr) => {
  const immutabilityChecks = useImmutabilityChecks();
  const deskId = useGetDeskIdByIndex(deskIndex);

  return immutabilityChecks?.uniqueRange?.(deskId, rangeStr) ?? false;
};

export const useCreateIntervalIsImmutableFn = (deskIndex, dayId) => {
  const immutabilityChecks = useImmutabilityChecks();
  const deskId = useGetDeskIdByIndex(deskIndex);

  return useEvent(({ field }) => {
    return (
      immutabilityChecks?.interval?.(deskId, dayId, field.intervalId) ?? false
    );
  });
};

function useGetDeskIdByIndex(index) {
  const { getValues } = useFormMethods();
  const desk = getValues(fieldPathBuilders.desk.name(index));
  return desk?.key;
}
